import * as React from "react";

const SvgIcnArrowLeft = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M13.797 15.887c.27.255.27.668 0 .922a.723.723 0 01-.979 0l-4.615-4.35a.626.626 0 010-.923l4.61-4.345a.723.723 0 01.978 0c.27.254.271.667 0 .922l-4.12 3.884 4.126 3.89z"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            strokeWidth={1}
        />
    </svg>
);

export default SvgIcnArrowLeft;
